import { IErrorResponse } from '~/Models/DTO/Error.models';
import { NeoState } from '../Reducers.interface';

export const selectLoading = (requestAction: string) => (state: NeoState): boolean =>
  state.app.loading[requestAction];

export const selectLanguage = (state: NeoState) => state.app.language;

export const selectErrors = (requestAction: string) => (state: NeoState): IErrorResponse | null => {
  const error = state.app.errors[requestAction];

  if (!error) {
    return null;
  }

  if (typeof error === 'string') {
    return {
      messages: [
        {
          key: error,
          defaultMessage: error,
        },
      ],
    };
  }

  if ((error as any)?.message) {
    return {
      messages: [
        {
          key: (error as any).message,
          defaultMessage: (error as any).message,
        },
      ],
    };
  }

  if ((error as any)?.title) {
    return {
      messages: [
        {
          key: (error as any).title,
          defaultMessage: (error as any).title,
        },
      ],
    };
  }

  if (
    !error.hasOwnProperty('message') &&
    !error.hasOwnProperty('messages') &&
    !error.hasOwnProperty('errors') &&
    !error.hasOwnProperty('error')
  ) {
    return {
      messages: [
        {
          key: 'error.key.failed.to.be.extracted',
          defaultMessage: 'error failed to be extracted',
        },
      ],
    };
  }

  return error;
};
